import { T } from "@/locales";

export const rules = {
  location_out: [{ required: true, message: T("请选择源库位"), trigger: "change" }],
  location_in: [{ required: true, message: T("请选择目标库位"), trigger: "change" }],
};
